<!-- Your color in every group you're in (accounts that joined groups; you set yours on People). -->
<script lang="ts">
  import { app } from "../lib/store.svelte.ts";
  import { member } from "../lib/member.svelte.ts";
  import { PERSON_COLORS } from "../lib/colors.ts";
  import { api } from "../lib/api.ts";

  const current = $derived(member.groups?.find((g) => g.me)?.me?.color ?? null);
  let picking = $state<string | null>(null);
  async function pick(color: string) {
    picking = color;
    try {
      await api("/api/member/color", { body: { color } });
      await member.refreshGroups();
      app.toast(`You're ${color} now`);
    } catch (e) {
      app.toast((e as Error).message, "error");
    } finally {
      picking = null;
    }
  }
</script>

<div class="colors" role="radiogroup" aria-label="Your color">
  {#each Object.entries(PERSON_COLORS) as [name, hex] (name)}
    <button
      class="color"
      role="radio"
      aria-checked={(picking ?? current) === name}
      aria-label={name}
      title={name}
      style:--c={hex}
      disabled={!member.groups?.length || picking !== null}
      onclick={() => pick(name)}
    ></button>
  {/each}
  <label class="custom" title="Any color">
    <input
      type="color"
      value={current && current.startsWith("#") ? current : "#3b7ddd"}
      onchange={(e) => pick((e.currentTarget as HTMLInputElement).value)}
      aria-label="Pick any color"
    />
    <span class="small">Any color</span>
  </label>
</div>

<style>
  .custom {
    display: inline-flex;
    gap: 6px;
    align-items: center;
  }

  .custom input {
    width: 34px;
    height: 34px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: none;
    cursor: pointer;
  }

  .colors {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .color {
    width: 34px;
    height: 34px;
    border: 0;
    border-radius: 50%;
    background: var(--c);
    cursor: pointer;
  }

  .color[aria-checked="true"] {
    box-shadow:
      0 0 0 3px var(--surface),
      0 0 0 5px var(--c);
  }
</style>
